import {Component, HostListener, OnInit} from '@angular/core';
import {GlobalService} from '../global.service';
import {ApiService} from '../api.service';
import {baseUrls} from '../appConstant';
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public imgSrc: any = 'assets/images/profile-picture.png';
  userDetails: any;
  public clickcheck = 0;
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.globalService.isBrowser) {
      if ($('.user-setting').hasClass('d-none') && $('.user-setting').length > 0){

      } else if ($('.user-setting').length > 0) {
        if (!document.getElementById('user-settings-menu').contains(event.target) && this.clickcheck !== 0) {
          this.clickcheck = 0;
          $('#user-setting').addClass('d-none');
        } else{
          this.clickcheck = 1;
        }
      }
    }
  }
  constructor(public globalService: GlobalService, public httpService: ApiService) {
    if (this.globalService.isBrowser){
      if (this.globalService.isLoggedIn){
        this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
        this.imgSrc = this.userDetails && this.userDetails['images'] && this.userDetails['images']['path']  ? baseUrls['images'] + this.userDetails['images']['path'] + this.userDetails['images']['name']:  'assets/images/profile-picture.png';
      } else {
        this.userDetails = '';
      }
    }
  }

  showprofilemenu($event, type: any){

    if (this.globalService.isBrowser){
      $('#' + type).removeClass('d-none');
    }
  }

  public logOut() {
    if (this.globalService.isBrowser) {
      this.userDetails = localStorage.getItem("userDetails") ? JSON.parse(localStorage.getItem("userDetails")) : null;

      let urlForgotPassword = "user/logout";
      // this.mode = 'indeterminate';
      let data = {userId: this.userDetails ? this.userDetails['_id'] : null};
      this.httpService.postFormDataBase(urlForgotPassword, data).subscribe(response => {
        if (response.success) {
          this.globalService.isLoggedIn = false;
          if (this.globalService.isBrowser) {
            let quantity = Number(localStorage.getItem('cartquantity'));
            console.log(quantity);
            while (quantity > -1) {
              localStorage.removeItem('cartdata_' + quantity);
              quantity = quantity - 1;
            }
            //   for(let i = quantity; i >= 0; i++){
            //     localStorage.removeItem('cartdata_' + i);
            //   }

            this.globalService.cartquantity = 0;
            localStorage.removeItem('cartquantity');
            localStorage.removeItem('userDetails');
            localStorage.removeItem('userToken');
            localStorage.removeItem("userEmail");
            localStorage.removeItem("userPass");
            localStorage.removeItem("countryNameSelectedForShipping");
            localStorage.removeItem("couponCode");
            localStorage.removeItem('moveToPlanPage');
            localStorage.removeItem('userSubscriptionPlan');
            window.location.href = '/';
          }
          // this.router.navigate(['/']);
        }
        localStorage.removeItem('userDetails');
        localStorage.removeItem('userToken');
        // this.mode = 'indeterminate';
      });
    }
  }

  ngOnInit(): void {
  }

}
